import { render, staticRenderFns } from "./SettingsContact.vue?vue&type=template&id=02ff80aa&scoped=true"
import script from "./SettingsContact.vue?vue&type=script&lang=js"
export * from "./SettingsContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ff80aa",
  null
  
)

export default component.exports